import instance from "./interceptor";

import { handleEncrypt, handleDecrypt } from "../../service/common";
import { system_api } from "../../service/system";

function request(
  url,
  params,
  options,
  method,
  {
    requestSecret = false,
    responseSecret = true,
    skipAuthRedirect = false,
  } = {},
) {
  return new Promise((resolve, reject) => {
    let data = {};
    if (method === "get") data = { params };
    if (method === "post")
      data = {
        data: requestSecret
          ? {
              pos: handleEncrypt({
                CRYPTO_KEY: process.env.REACT_APP_CRYPTO_KEY,
                text: JSON.stringify(params),
              }),
            }
          : params,
      };

    instance({
      url,
      method,
      ...options,
      ...data,
    })
      .then((result) => {
        setTimeout(() => {
          let data = result.data;
          if (data) {
            if (data.data && responseSecret) {
              data.data = handleDecrypt({
                CRYPTO_KEY: process.env.REACT_APP_CRYPTO_KEY,
                text: data.data,
              });
              data.data = JSON.parse(data.data);
            }

            if (data.data) {
              data.Response = 1;
              data.headers = result.headers;
              if (!data.message) data.message = "資訊異常，請聯繫維修人員";
              resolve(data);
            } else {
              resolve({ Response: -1, data: result, message: "no Response" });
            }
          } else {
            resolve({ Response: -1, message: "無回應" });
          }
        }, system_api.delay);
      })
      .catch((error) => {
        let { code, response } = error;
        setTimeout(() => {
          let Response = response?.status ? response.status : -1,
            message = "",
            statusMsg = {
              401: "超過使用時限，請重新登入",
              403: "無權限使用",
              404: "無此 API",
              500: "資訊異常，請聯繫維修人員",
            },
            codeMsg = {
              ECONNABORTED: "查詢逾時，請調整查詢條件後重試",
              ERR_NETWORK: "無法連線，請檢查網路是否正常",
            };

          if (code === "ERR_CANCELED") {
            resolve({
              Response: -2,
              canceled: true,
              message: "",
            });
            return;
          }

          if (code === "ECONNABORTED") {
            resolve({
              Response: -3,
              timeout: true,
              message: codeMsg[code],
            });
            return;
          }

          if ([401, 403, 404, 500].indexOf(response?.status) !== -1) {
            message = statusMsg[response.status];
          } else if (code === "ERR_NETWORK") {
            message = codeMsg[code];
          } else {
            message = "資訊異常，請聯繫維修人員";
          }

          if (Response === 401 && !skipAuthRedirect) {
            setTimeout(() => {
              localStorage.removeItem("user");
              localStorage.removeItem("userControl");
              window.location.href = "/login";
            }, 1500);
          }

          resolve({
            Response,
            networkError: code === "ERR_NETWORK",
            message,
          });
        }, system_api.delay);
      })
      .finally(() => {});
  });
}

function get(url, params, options, settings) {
  return request(url, params, options, "get", settings);
}

function post(url, params, options, settings) {
  return request(url, params, options, "post", settings);
}

export default {
  get,
  post,
};
